// @ts-nocheck
/**
 * Construct API endpoint URL based on environment
 * Similar to mtp-frontend-analytics-sdk but adapted for Gatsby
 *
 * Gatsby uses GATSBY_ prefix for environment variables exposed to browser.
 * This helper intelligently constructs the API URL for development and production.
 */
export function hostUrl() {
  // Check if we're in browser context
  const isBrowser = typeof window !== 'undefined';

  // Priority 1: Explicit analytics endpoint override (useful for testing)
  if (isBrowser && window.ENV?.ANALYTICS_ENDPOINT) {
    return window.ENV.ANALYTICS_ENDPOINT;
  }

  // Priority 2: Gatsby environment variables
  // These are set in .env.development and .env.production
  const host = process.env.GATSBY_HOST || 'app.magictableplanner.com';
  const protocol = process.env.GATSBY_PROTOCOL || 'https';
  const port = process.env.GATSBY_PORT || '';

  const baseUrl = `${protocol}://${host}${port ? `:${port}` : ''}`;

  // In production, add /api prefix to match backend routing
  // In development, connect directly to backend port
  const apiPrefix = process.env.NODE_ENV === 'production' ? '/api' : '';

  return `${baseUrl}${apiPrefix}`;
}

/**
 * Get the full analytics tracking endpoint
 */
export function getAnalyticsEndpoint() {
  return `${hostUrl()}/events`;
}
